import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "components/fields/InputField";
import { useAuth } from "context/AuthProvider";
import { MdMarkEmailRead, MdOutlineMail } from "react-icons/md";

function CheckEmail() {
  return (
    <section>
      <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        {/* Sign in section */}
        <div className="mt-[10vh] w-full max-w-full flex-col items-center rounded-xl p-6 shadow-[0_0px_6px_rgba(0,0,0,0.1)] xl:max-w-[420px]">
          <span className="text-brand-500">
            <MdMarkEmailRead className="h-20 w-20 m-auto" />
          </span>
          <h4 className="mb-2.5 text-4xl text-center font-bold text-navy-700 dark:text-white">
            Check your email
          </h4>
          <p className="mb-4 ml-1 text-gray-600 text-center">
            Please check your email inbox for instructions on setting your
            password. If you don't see the email, please check your spam folder
            as well.
          </p>
          {/* <div className="mt-4">
            <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
              Already registered?
            </span>
            {
              <Link
                to="/sign-in"
                className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
              >
                Login
              </Link>
            }
          </div> */}
        </div>
      </div>
    </section>
  );
}
export default CheckEmail;
